<template>

    
      <div class="itemsRow">
            <div class="rowTitle">{{localize(`${title}`)}}</div>

            <template v-if="$device.mobile==false">       
                <div class="wrapper">
                    <div @click="movePage(-1)" class="pageBtn btnPre">
                        <i class="fas fa-chevron-left"></i>
                    </div>
                    <div @click="movePage(1)" class="pageBtn btnNext">
                        <i class="fas fa-chevron-right"></i>
                    </div>
                    <router-link v-for="item in pageItems" class="item"
                        :title="item.CatalogNo"
                        :key="item.PRO_ID"
                        :to="item.CatalogNo">  
                            <catalog-thumb 
                            :item="item"
                            :size="big"
                            ></catalog-thumb>
                    </router-link>
                </div>
            </template>

            <!-- mobile version -->
            <template v-if="$device.mobile">
                <div class="wrapperX">
                    <div class="scrollsX" ref="mscroller">
                        <router-link v-for="item in pageItems" class="itemX"
                            :title="item.CatalogNo"
                            :key="item.PRO_ID"
                            :to="item.CatalogNo">  
                                <catalog-thumb 
                                :item="item"
                                :size="big"
                                ></catalog-thumb>
                        </router-link>
                    </div>
                </div>
            </template>
            <!-- end mobile version -->

      </div>
    </template>



<script>
    import { mapState, mapActions, mapGetters } from "vuex";
    import CatalogThumb from "@/components/catalog/CatalogThumb.vue";

    export default {
        data() {
            return {
                contentReady: false,
                pIndex: 0,
                pSize: 6,
                pageItems:[]
            };
        },
        props: ["title", "items"],
        components: {CatalogThumb},
        mounted()
        {
            this.initItems();
        },
        methods:
        {
            movePage(dir)
            {
                //alert("$device.mobile="+this.$device.mobile);

                var pagesCount = Math.ceil(this.items.length/this.pSize);
                this.pIndex=this.pIndex+dir;
                if(this.pIndex<0){
                    this.pIndex = 0;
                }
                if(this.pIndex>pagesCount-1){
                    this.pIndex = 0;
                }
                this.initItems();
            },
            initItems()
            {
                var takeCount = this.pSize;
                var skipCount = this.pSize * this.pIndex;
                this.pageItems = _(this.items).drop(skipCount).take(takeCount).value();
                if(this.$device.mobile){
                    this.$refs.mscroller.scrollLeft=0;//scroll back to the left
                }
            },
        },
        watch: {
            'items'()
            {
                this.initItems();
            }
        },
    };
</script>

<style scoped>
    .rowTitle
    {
        color:#787878;
        border-top: solid 1px #e6e6e6;
        padding-top: 20px;
        font-weight: 600 !important;
        padding-bottom: 20px;
        font-size: 16px;
        letter-spacing: 0px;
    }
    .wrapper
    {
        width:100%;
        position: relative;
        display: grid;
        width: 100%;
        margin: initial;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
        column-gap: 20px;
        row-gap: 1em;
        padding-bottom: 30px;
    }
    .item {
        box-sizing: border-box;
    }
    .item span {
        color: white;
        margin: 30px;
        font-size: 30px;
    }
    .itemsRow
    {
        clear: both;        
        position: relative;
    }


    .pageBtn
    {
        position: absolute;
        top: 50px;
        background-color: #f9f9f9;
        width: 40px;
        height: 40px;
        border-radius: 100%;
        cursor: pointer;
    }
    .pageBtn:hover
    {
        background-color: #0976bd;
    }
    .pageBtn i
    {
        position: relative;
        transform: translate(-50%,-50%);
        color:#787878;
        opacity: 0.7;
        font-size: 20px;        
    }
    .pageBtn:hover i
    {
        color:#fff;opacity: 1;
    }
    .btnNext
    {        
        right: -70px;
    }
    .btnNext i{
        top:22px;
        left: 21px;
    }
    .btnPre
    {
        left: -70px;
    }
    .btnPre i{
        top:22px;
        left: 19px;
    }



    @media screen and (max-width:900px) {
        .itemsRow
        {
            padding-bottom: 30px;
        }
        .wrapper
        {
            position: relative;
        }
        .scroller 
        {
            overflow-x: scroll;
            overflow-y: hidden;
            height: 180px;
            white-space:nowrap;
            padding: 0px !important;
            display:initial;
            width: 100%;
            margin: initial;
            grid-template-columns: none;

        }
        .item {
            display: inline-block;
        }





    .wrapperX {
        margin: auto; 
        text-align: center; 
        position: relative;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        margin-bottom: 20px !important;
        width: 100%;
        padding-top: 5px;
    }
    .scrollsX { 
        overflow-x: scroll;
        overflow-y: hidden;
        height: 200px;
        white-space:nowrap;
    } 
    .imageDiv img { 
        box-shadow: 1px 1px 10px #999; 
        margin: 2px;
        max-height: 50px;
        cursor: pointer;
        display:inline-block;
    *display:inline;
    *zoom:1;
    vertical-align:top;
    }

    .itemX {
        box-sizing: border-box;
        display: inline-block;
        padding-right: 20px;
        width: 55vw;
        vertical-align:top;
    }
    .itemX span {
        color: white;
        margin: 30px;
        font-size: 30px;
        text-align: left;
        white-space:initial;
    }

        
    }
</style>
